module.exports = __webpack_public_path__ + "img/logo.0c2c680b.svg";